import React from "react";

function BS4_ButtonGroups() {
  return (
    <div>
      <h1>BS4_ButtonGroups Component</h1>
      <p>This is the BS4_ButtonGroups tutorial page content.</p>
    </div>
  );
}

export default BS4_ButtonGroups;
